<script setup lang="ts">
import { Head } from '@inertiajs/vue3'

import AppearanceTabs from '@/components/AppearanceTabs.vue'
import SettingsCard from '@/components/settings/SettingsCard.vue'
import SettingsPanel from '@/components/settings/SettingsPanel.vue'
import { dashboardLayout } from '@/lib/layouts'

defineOptions({
  layout: dashboardLayout,
})
</script>

<template>
  <Head title="Appearance settings" />

  <SettingsPanel
    title="Settings"
    description="Manage profile, security, sessions, and appearance preferences."
  >
    <SettingsCard
      title="Appearance"
      description="Choose how the interface should render on this device."
      icon="i-lucide-palette"
    >
      <AppearanceTabs />
    </SettingsCard>
  </SettingsPanel>
</template>
